export function isLocalStoragePhotoUrl(url: string): boolean {
  let photoUrl: URL;
  try {
    photoUrl = new URL(url, window.location.href);
  } catch {
    return false;
  }
  const isLocalHost =
    ['localhost', '127.0.0.1', '[::1]'].includes(photoUrl.hostname) ||
    photoUrl.hostname.endsWith('.localhost');

  return (
    isLocalHost &&
    ['http:', 'https:'].includes(photoUrl.protocol) &&
    /^\/dms\/_local\/file-storage\/[^/]+\/original$/.test(photoUrl.pathname) &&
    photoUrl.searchParams.has('_hash')
  );
}
